/**
 * PWA Update Prompt
 *
 * Shows when a new version of the app is available
 */

import { RefreshCw, X } from 'lucide-react';
import { usePWAUpdate } from '../../hooks/useOffline';

export function UpdatePrompt() {
  const { needsUpdate, applyUpdate, dismissUpdate } = usePWAUpdate();

  if (!needsUpdate) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-navy text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3">
        <RefreshCw className="w-5 h-5 text-primary" />
        <div className="flex-1">
          <p className="font-medium text-sm">Update available</p>
          <p className="text-xs text-gray-300">
            A new version of MedTranslate is ready.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={applyUpdate}
            className="px-3 py-1.5 bg-primary text-white rounded-lg text-xs font-medium hover:bg-primary-dark transition-colors"
          >
            Update
          </button>
          <button
            onClick={dismissUpdate}
            className="p-1.5 text-gray-400 hover:text-white transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdatePrompt;
